<div class="container mx-auto space-y-6 px-4 py-6">
  <header>
    <h1 hlmH3>Zahlungen</h1>
    <p hlmMuted class="mt-1">Kontostand, eingegangene Zahlungen und Auszahlungen</p>
    @if (shopFeeRate !== null) {
      <p hlmMuted class="mt-1 text-sm">
        @if (shopFeeRate < standardFeeRate) {
          Schenkwerk-Gebühr: {{ formatRate(shopFeeRate) }} statt
          {{ formatRate(standardFeeRate) }} dank deiner Empfehlungen ·
          <a
            routerLink="/settings"
            [queryParams]="{ tab: 'recommend' }"
            class="underline underline-offset-4"
            >Details</a
          >
        } @else {
          Schenkwerk-Gebühr: {{ formatRate(shopFeeRate) }} je Verkauf ·
          <a
            routerLink="/settings"
            [queryParams]="{ tab: 'recommend' }"
            class="underline underline-offset-4">
            Mit Empfehlungen weniger zahlen
          </a>
        }
      </p>
    }
  </header>

  @if (needsStripeSetup) {
    <div hlmAlert variant="warning">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>Zahlungen noch nicht eingerichtet</p>
      <p hlmAlertDescription>
        Sobald du die Zahlungsabwicklung eingerichtet hast, siehst du hier Kontostand, Zahlungen und
        Auszahlungen.
      </p>
      <a
        hlmBtn
        variant="outline"
        size="sm"
        class="mt-2"
        [routerLink]="['/settings']"
        [queryParams]="{ tab: 'payments' }">
        Zahlungen einrichten
      </a>
    </div>
  }

  @if (error) {
    <div hlmAlert variant="destructive">
      <ng-icon name="lucideTriangleAlert" />
      <p hlmAlertTitle>{{ error }}</p>
      <div hlmAlertAction>
        <button hlmBtn variant="ghost" size="icon-sm" aria-label="Schließen" (click)="error = null">
          <ng-icon name="lucideX" />
        </button>
      </div>
    </div>
  }

  <!-- Stripe mounts its notification banner here. The element has to stay in the
       DOM for getElementById, so it is hidden rather than removed — otherwise the
       zero-height banner would still claim a slot in the container's spacing. -->
  <div id="stripe-notification-mount" [class.hidden]="!hasStripeNotifications"></div>

  <!-- The tab bar only switches visibility: every Stripe mount point has to stay
       in the DOM, otherwise getElementById would not find it on init. -->
  <hlm-tabs [tab]="activeTabId" class="w-full">
    <hlm-tabs-list variant="line" class="w-fit">
      @for (tab of tabs; track tab.id; let i = $index) {
        <button [hlmTabsTrigger]="tab.id" (click)="onTabChange(i)">
          <ng-icon [name]="tab.icon" />
          {{ tab.label }}
        </button>
      }
    </hlm-tabs-list>
  </hlm-tabs>

  <section hlmCard>
    <div hlmCardContent class="pt-6">
      <div
        [style.display]="activeTabId === 'payouts' ? 'block' : 'none'"
        class="relative min-h-[400px]">
        <div
          id="stripe-payouts-mount-loader"
          class="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <hlm-spinner class="text-[length:--spacing(8)]" />
          <p hlmMuted class="text-center text-sm">
            Wir laden deine Auszahlungen.<br />Bitte habe etwas Geduld…
          </p>
        </div>
        <div id="stripe-payouts-mount"></div>
      </div>

      <div
        [style.display]="activeTabId === 'balances' ? 'block' : 'none'"
        class="relative min-h-[400px]">
        <div
          id="stripe-balances-mount-loader"
          class="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <hlm-spinner class="text-[length:--spacing(8)]" />
          <p hlmMuted class="text-center text-sm">
            Wir laden deine Bilanz-Übersicht.<br />Bitte habe etwas Geduld…
          </p>
        </div>
        <div id="stripe-balances-mount"></div>
      </div>

      <div
        [style.display]="activeTabId === 'payments' ? 'block' : 'none'"
        class="relative min-h-[400px]">
        <div
          id="stripe-payments-mount-loader"
          class="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <hlm-spinner class="text-[length:--spacing(8)]" />
          <p hlmMuted class="text-center text-sm">
            Wir laden deine letzten Zahlungen.<br />Bitte habe etwas Geduld…
          </p>
        </div>
        <div id="stripe-payments-mount"></div>
      </div>
    </div>
  </section>
</div>
